import { platform } from '../platform'

type OneSignalPluginGlobal = {
  initialize?: (appId: string) => void
  login?: (externalUserId: string) => void
  logout?: () => void
  Notifications?: {
    requestPermission: (fallback?: boolean) => Promise<boolean>
  }
}

function getOneSignal(): OneSignalPluginGlobal | null {
  const plugins = (globalThis as { plugins?: { OneSignal?: OneSignalPluginGlobal } }).plugins
  return plugins?.OneSignal ?? null
}

export async function initOneSignal(externalUserId: string | null) {
  if (!platform.isNative()) return
  const OneSignal = getOneSignal()
  if (!OneSignal) {
    console.warn('[onesignal] plugin not available')
    return
  }
  const appId = import.meta.env.VITE_ONESIGNAL_APP_ID
  if (!appId) {
    console.warn('[onesignal] VITE_ONESIGNAL_APP_ID missing')
    return
  }
  OneSignal.initialize?.(appId)
  if (externalUserId) {
    OneSignal.login?.(externalUserId)
  }
  await OneSignal.Notifications?.requestPermission(true)
}

export function logoutOneSignal() {
  if (!platform.isNative()) return
  const OneSignal = getOneSignal()
  OneSignal?.logout?.()
}
